import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalender = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.255,
	height: 18.19,
	viewBox: "0 0 18.255 18.19",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1513",
		"data-name": "Group 1513",
		transform: "translate(-385 -1245)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1471",
				"data-name": "Path 1471",
				d: "M388.5,1248.5h-3v14.742h17.255V1248.5h-3",
				transform: "translate(0 -0.552)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2064",
				"data-name": "Path 2064",
				d: "M0,0H17.255",
				transform: "translate(385.5 1247.981)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2063",
				"data-name": "Path 2063",
				d: "M0,2.1H17.255",
				transform: "translate(385.5 1248.779)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_498",
				"data-name": "Rectangle 498",
				width: 1.909,
				height: 2.863,
				transform: "translate(388.377 1245.5)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_499",
				"data-name": "Rectangle 499",
				width: 3.817,
				height: 3.817,
				transform: "translate(396.058 1256.198)",
				fill: "none",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_502",
				"data-name": "Rectangle 502",
				width: 1.909,
				height: 2.863,
				transform: "translate(397.969 1245.5)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	})
});
export default SvgCalender;
